export enum BillEntityType {
  COMPANY = 'COMPANY',
  COMPANY_VENDOR = 'COMPANY_VENDOR',
  BILL = 'BILL',
  BILL_PAYMENT = 'BILL_PAYMENT',
  BILL_TO_PAYMENT_RELATION = 'BILL_TO_PAYMENT_RELATION',
}
